import { useState, useEffect, forwardRef } from "react";
import {
  Button,
  Form,
  Nav,
  Modal,
  Tab,
  Table,
  InputGroup,
  Dropdown,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../../assets/global/url";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../../../utils/checkNumberValidator";
import CheckNumberError from "../../../../components/inputs/CheckNumberError";
import { customStyles } from "../../../../assets/table-style";
import DataTable from "react-data-table-component";
// import { jwtDecode } from "jwt-decode";
import useDecodeToken from "../../../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { PaginationControls } from "../../../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../../../hooks/customHook/paginationHook/useServerPagination";
import Select from "react-select";
import { selectCustomStyles } from "../../../../assets/global/selectCustomStyles";
import {
  currencySymbol,
  formatCurrency,
  formatToTwoDecimal,
  parseNumber,
  truncateToTwoDecimals,
} from "../../../../utils/numberFormatter";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import TypedDateInput from "../../../../components/inputs/TypedDateInput";
import { checkCutoffDate } from "../../../../utils/cutoffDateValidation";
import { ExpensesHistoryModal } from "./ExpensesHistoryModal";
import NumberInDecimals from "../../../../components/inputs/NumberFormatted";

const dropdownFilters = [
  { value: "all", label: "All" },
  { value: "transaction_id", label: "Transaction ID" },
  { value: "expensesCheque", label: "Cheque Number" },
  { value: "desc", label: "Remarks" },
  { value: "expenses_type", label: "Expenses Type" },
  { value: "expenses_date", label: "Expenses Date" },
  { value: "totalAmount", label: "Amount" },
];

// Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
// (TypedDateInput), or picked from the calendar. Only a complete date reaches
// handleDateChange, so the cutoff check doesn't run on a half-typed date.
const CustomInput = forwardRef(
  (
    {
      value,
      onClick,
      onChange,
      onBlur,
      onFocus,
      onKeyDown,
      generateYears,
      disabled,
    },
    ref,
  ) => {
    return (
      <TypedDateInput
        className="form-control p-2 w-100"
        style={{ cursor: disabled ? "pointer" : "text" }}
        onClick={(e) => {
          if (onClick) onClick(e);

          let selectedYear = new Date().getFullYear();
          if (value) {
            const parsed = new Date(value);
            // Extract year safely if value is a valid date
            if (!isNaN(parsed.getTime())) {
              selectedYear = parsed.getFullYear();
            }
          }

          // Reset/Initialize Year List based on selected date
          if (generateYears && typeof generateYears === "function") {
            generateYears(selectedYear);
          }
        }}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        value={value}
        ref={ref}
        disabled={disabled}
        required
      />
    );
  },
);

const NewViewPayLocalExpenses = ({
  authrztn,
  setId,
  setIdToAdd,
  setEdit, // To determine if user is still editing then suddenly navigates to other page
  setRoute,
}) => {
  const userLoggedID = useDecodeToken();

  // Cutoff warning for Processed Date / Issued Date (replaces
  // usePostedCutoffValidation). Warns when there's no cutoff yet or it's
  // already posted; a posted date is still cleared, same as before.
  // Skips partially typed years (e.g. "202") so it only fires on a full date.
  const warnCutoffDate = (selectedDate, clearDate, dateLabel) => {
    if (!selectedDate || new Date(selectedDate).getFullYear() < 1000) return;
    checkCutoffDate(selectedDate, dateLabel).then((status) => {
      if (status === "posted") clearDate("");
    });
  };
  const navigate = useNavigate();
  const { id, foreign_url } = useParams();
  const [searchParams] = useSearchParams();

  const [isEditing, setIsEditing] = useState(false);

  const [bulkExpenses, setBulkExpenses] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [payments, setPayments] = useState([]);
  const [addDeducts, setAddDeducts] = useState([]);

  const [expensesTotalAmount, setExpensesTotalAmount] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [additionalTotalAmount, setAdditionalTotalAmount] = useState(0);
  const [deductionTotalAmount, setDeductionTotalAmount] = useState(0);
  const [activeTab, setActiveTab] = useState("paymentList");

  const [selected_currency_id, setSelected_currency_id] = useState("");
  const [currency_db, setCurrency_db] = useState([]);
  const [currencyName, setCurrencyName] = useState("");

  const [payDate, setPayDate] = useState(null);
  const [status, setStatus] = useState("");

  const [isAmountDisabled, setIsAmountDisabled] = useState(true);
  const [currentDate, setCurrentDate] = useState("");
  const [isCutoffPosted, setIsCutoffPosted] = useState(false);
  const [isCutoffExists, setIsCutoffExists] = useState(true);
  const [currencyRate, setCurrencyRate] = useState(1);
  const [overallDiscount, setOverallDiscount] = useState(0);

  const [transactionToGetBack, setTransactionToGetBack] = useState([]);

  const [accessType, setAccessType] = useState("");
  // Access type (Management/Employee) of the logged in user, used to decide
  // whether the account balance is shown or hidden on this screen.
  const fetchAccessType = () => {
    axios
      .get(`${BASE_URL}/userRole/getUserAccessType/${userLoggedID}`)
      .then((res) => {
        setAccessType(res.data.accessType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (userLoggedID) {
      fetchAccessType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedID]);

  const [expenses, setExpenses] = useState({
    additional: {
      0: {
        subject1: "",
        subject2: "",
        subject3: "",
        payment_method: "",
        remarks: "",
        check: "",
        amount: "",
        subject2Options: [],
        subject3Options: [],
        type: "additional",
        disabledSubject2: true,
        disabledSubject3: true,
        disabledAmount: true,
        currentAmount: "",
      },
    },
    deduction: {
      0: {
        subject1: "",
        subject2: "",
        subject3: "",
        payment_method: "",
        remarks: "",
        check: "",
        amount: "",
        subject2Options: [],
        subject3Options: [],
        type: "deduction",
        disabledSubject2: true,
        disabledSubject3: true,
        disabledAmount: true,
        currentAmount: "",
      },
    },
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [removePaymentListId, setRemovePaymentListId] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterColumn, setFilterColumn] = useState("all");
  const [isAddedTransactions, setIsAddedTransactions] = useState([]);
  const [selectedRowTransactions, setSelectedRowTransactions] = useState([]);
  const [floatPayment, setFloatPayment] = useState([]);

  const submitModal = () => {
    const mergedData = [
      ...new Set([...selectedRow, ...selectedRowTransactions]),
    ];

    fetchAvailableExpenses(mergedData);
    setSelectedRowTransactions(mergedData);

    setIsAddedTransactions((prev) => {
      return prev.filter((item) => !mergedData.includes(item.transaction_id));
    });

    setFilterColumn("all");
    setSearchTerm("");
    // setSelectedRow([]);
    pagination.setCurrentPage(1);
    setShow(false);
  };

  const deleteItem = async (item, index) => {
    if (transactions.length === "1") {
      // Prevent deleting the last row if there's only one row
      return;
    }

    setTransactions((prev) => {
      return prev.filter((_, i) => index !== i);
    });

    setSelectedRow((prev) => {
      return prev.filter((item) => item !== item.transaction_id);
    });

    setSelectedRowTransactions((prev) => {
      return prev.filter((itemRow) => itemRow !== item.transaction_id);
    });

    setRemoveTransactionList((prev) => {
      return [...prev, String(item.id)];
    });

    if (item.isAdded === true) {
      // await axios.put(
      //   `${BASE_URL}/paylocalexpenses/deleteOrderListTransaction`,
      //   {
      //     id,
      //     idToRemove: item.id,
      //   },
      // );

      setTransactionToGetBack((prev) => [...prev, item.id]);
      setIdToAdd((prev) => [...prev, item.id]);
      setId(id);
      setRoute("paylocalexpenses");
    }
  };

  const handleIndividualCheckBoxChange = (transaction_id) => {
    if (selectedRow.includes(transaction_id)) {
      setSelectedRow((prev) => {
        return prev.filter((item) => transaction_id !== item);
      });
    } else {
      setSelectedRow((prev) => {
        return [...prev, transaction_id];
      });
    }
  };

  const handleAllCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked === true) {
      setSelectedRow(localExpensesData.map((item) => item.transaction_id));
    } else {
      setSelectedRow([]);
    }
  };

  const columns = [
    {
      name: (
        <input type="checkbox" onChange={(e) => handleAllCheckboxChange(e)} />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRow.includes(row.transaction_id)}
          onChange={() => handleIndividualCheckBoxChange(row.transaction_id)}
        />
      ),
    },
    {
      name: "Transaction ID",
      selector: (row) => (
        <>
          <div className="d-none">{row.transaction_id}</div>
          <div>{row.client_transaction_id}</div>
        </>
      ),
    },
    {
      name: "Cheque Number",
      selector: (row) => (row.expensesCheque ? row.expensesCheque : "---"),
    },
    {
      name: "Remarks",
      selector: (row) => (row.desc ? row.desc : "---"),
    },
    {
      name: "Expenses Type",
      selector: (row) =>
        `${row.expenses2.expenses_one.expenses_type_one} (${row.expenses2.sub_type})`,
    },
    {
      name: "Expenses Date",
      selector: (row) => format(row.expenses_date, "MMM/dd/yyyy"),
    },
    {
      name: "Amount",
      selector: (row) =>
        row.totalAmount.toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }),
    },
  ];

  const handleSubject1AddDeductExpensesChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: {
          ...prev[expenseType][rowId],
          subject1: value,
          subject2: "",
          subject3: "",
          disabledSubject2: true,
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
    }));

    axios
      .get(BASE_URL + "/paylocalexpenses/getSubjectAddDeductExpenses", {
        params: { account_selected: value },
      })
      .then((res) => {
        setExpenses((prev) => ({
          ...prev,
          [expenseType]: {
            ...prev[expenseType],
            [rowId]: {
              ...prev[expenseType][rowId],
              subject2Options: res.data,
              disabledSubject2: false,
            },
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubject2AddDeductExpensesChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: {
          ...prev[expenseType][rowId],
          subject2: value,
          subject3: "",
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
    }));

    if (value === "Loan_Unique") {
      axios
        .get(
          BASE_URL + "/paylocalexpenses/getSubject3AddDeductExpensesFORLOAN",
          {
            params: {
              selected_currency_id,
            },
          },
        )
        .then((res) => {
          setExpenses((prev) => ({
            ...prev,
            [expenseType]: {
              ...prev[expenseType],
              [rowId]: {
                ...prev[expenseType][rowId],
                subject3Options: res.data,
                disabledSubject3: false,
              },
            },
          }));
        });
    } else {
      axios
        .get(BASE_URL + "/paylocalexpenses/getSubject3AddDeductExpenses", {
          params: {
            subjectId: value,
            totalAmountSum,
            selected_currency_id,
          },
        })
        .then((res) => {
          setExpenses((prev) => ({
            ...prev,
            [expenseType]: {
              ...prev[expenseType],
              [rowId]: {
                ...prev[expenseType][rowId],
                subject3Options: res.data,
                disabledSubject3: false,
              },
            },
          }));
        });
    }
  };

  const handleSubject3AddExpensesChange = (
    rowId,
    value,
    expenseType,
    loanORAccount,
    currAmount,
  ) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: {
          ...prev[expenseType][rowId],
          subject3: value,
          LoanORAccount: loanORAccount,
          disabledAmount: false,
          currentAmount: currAmount,
        },
      },
    }));
  };

  const handleRemarksChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: { ...prev[expenseType][rowId], remarks: value },
      },
    }));
  };

  const handleAmountChange = (rowId, value, expenseType) => {
    setExpenses((prev) => {
      const currentRow = prev[expenseType][rowId];

      if (value === ".") {
        value = "0.";
      }

      let inputValue = value.replace(/[^0-9.]/g, "");
      let [integerPart, decimalPart] = inputValue.split(".");

      if (integerPart) {
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      let formattedValue =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
      let formatAmount = inputValue.replace(/,/g, "");
      let numericValue = parseFloat(formatAmount) || 0;

      if (numericValue > currentRow.currentAmount) {
        swal({
          icon: "error",
          title: "Enter another amount",
          text: `Amount cannot exceed ${currentRow.currentAmount.toLocaleString(
            "en-US",
            { minimumFractionDigits: 2, maximumFractionDigits: 2 },
          )}`,
          buttons: false,
          timer: 2000,
        });
        return prev; // Prevent updating state
      }

      return {
        ...prev,
        [expenseType]: {
          ...prev[expenseType],
          [rowId]: { ...currentRow, amount: formattedValue }, // Store formatted value
        },
      };
    });
  };
  const handleRateChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: { ...prev[expenseType][rowId], rate: value },
      },
    }));
  };

  const handleRemoveRow = (rowId, type) => {
    setExpenses((prev) => {
      const updated = { ...prev[type] };
      delete updated[rowId];
      return { ...prev, [type]: updated };
    });
  };

  const handleCurrencyChange = (value) => {
    setSelected_currency_id(value);
  };

  const [isCurrencyFetched, setIsCurrencyFetched] = useState(false);

  const fetchCurrency = async () => {
    await axios
      .get(BASE_URL + "/currency/fetchCurrency")
      .then((response) => {
        setCurrency_db(response.data);
        setIsCurrencyFetched(true);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  };

  const pagination = useServerPagination(
    BASE_URL + "/paylocalexpenses/getLocalExpensesData",
    10,
  );

  const fetchAvailableExpenses = async (selectedTransactions = []) => {
    pagination.updateParams({
      foreign: foreign_url,
      currency_id: "11111111-1111-1111-1111-111111111111",
      searchText: searchTerm,
      filterColumn,
      selectedTransactions,
    });
  };

  const foreignExpenses = foreign_url === "local" ? "LOCAL" : "OVERSEAS";
  const editPermission =
    foreignExpenses === "LOCAL"
      ? "LocalExpenses-Edit"
      : "OverseasExpenses-Edit";
  const approvePermission =
    foreignExpenses === "LOCAL"
      ? "LocalExpenses-Approve"
      : "OverseasExpenses-Approve";

  const dateToday = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    setCurrentDate(dateToday());
  }, []);

  const reloadTableBelow = () => {
    axios
      .get(`${BASE_URL}/paylocalexpenses/localExpensesSpecificDataFetching`, {
        params: { id: id },
      })
      .then((res) => {
        const {
          data,
          dataTransaction,
          dataPayment,
          dataAddDeduct,
          isPosted,
          cutoffExists,
        } = res.data;
        setBulkExpenses(data);
        setTransactions(
          dataTransaction.map((item) => {
            return {
              ...item.expense,
              expensesDiscountType: item.expenses_discount_type || "percent",
              expensesDiscountValue: item.expenses_discount_value || "",
              expensesDiscountOperator: item.expenses_discount_operator || "+",
              expensesDiscountConverted: item.expenses_discount_converted || 0,
            };
          }),
        );
        console.log(dataTransaction);
        console.log(dataPayment);
        setPayments(dataPayment);
        setAddDeducts(dataAddDeduct);
        setPayDate(
          data.status === "Approved" || data.status === "Partially-Paid"
            ? null
            : data.pay_date,
        );
        setStatus(data.status);
        setCurrencyRate(data.rate);
        setIsCutoffPosted(isPosted);
        setIsCutoffExists(cutoffExists);

        // Initial calculation of totals
        calculateTotals(dataTransaction, dataPayment, dataAddDeduct, expenses);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    reloadTableBelow();
  }, [isEditing]);

  useEffect(() => {
    fetchCurrency();
    fetchAvailableExpenses();

    reloadTableBelow();
  }, [id]);

  useEffect(() => {
    if (pagination.data.data) {
      setLocalExpensesData(
        isAddedTransactions.length > 0
          ? [
              ...pagination.data.data?.filter(
                (data) =>
                  !transactions
                    .map((item) => item.transaction_id)
                    .includes(data.transaction_id),
              ),
              ...isAddedTransactions.filter((item) => {
                if (item.isAdded === true) {
                  const expenseType = `${item.expenses2.expenses_one.expenses_type_one} (${item.expenses2.sub_type})`;
                  const includesSearchTerm = (str, searchTerm) => {
                    return String(str)
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase());
                  };
                  // Handle search for all
                  if (filterColumn === "all") {
                    return [
                      item.transaction_id,
                      item.desc,
                      item.expenses_date,
                      item.totalAmount,
                      expenseType,
                    ].some((value) => includesSearchTerm(value, searchTerm));
                  } else {
                    let searchResult;
                    filterColumn === "expenses_type"
                      ? // Handle expenses_type search
                        (searchResult = includesSearchTerm(
                          expenseType,
                          searchTerm,
                        ))
                      : // Handle individual column search
                        (searchResult = includesSearchTerm(
                          item[filterColumn],
                          searchTerm,
                        ));
                    return searchResult;
                  }
                }
                return false;
              }),
            ]
          : pagination.data.data?.filter(
              (data) =>
                !transactions
                  .map((item) => item.transaction_id)
                  .includes(data.transaction_id),
            ),
      );
    }

    if (pagination?.data?.items) {
      // Skip if all selectedRows already exist in Expense List Table
      const existingIds = transactions.map((item) => item.transaction_id);
      const isFullySynced =
        selectedRowTransactions.every((id) => existingIds.includes(id)) &&
        transactions.length === selectedRowTransactions.length;

      if (isFullySynced) return;

      const newItems = pagination.data.items
        .filter(
          (item) =>
            selectedRowTransactions.includes(item.transaction_id) &&
            !existingIds.includes(item.transaction_id),
        )
        .map((item) => ({
          ...item,
          expensesDiscountType: "percent",
          expensesDiscountValue: "",
          expensesDiscountOperator: "+",
          expensesDiscountConverted: 0,
        }));

      if (newItems.length > 0) {
        setTransactions((prev) => [...prev, ...newItems]);
        setAddedTransactionList((prevList) => [
          ...prevList,
          ...new Set(newItems.map((i) => String(i.id))),
        ]);
      }
    }
  }, [pagination.data.data]);

  // Use an additional useEffect to wait until currency data is fetched
  useEffect(() => {
    if (isCurrencyFetched && transactions.length > 0) {
      // Determine and set currency symbol
      const currency_symbol = currency_db.find(
        (currency) =>
          String(currency.id) === String(transactions[0]?.currency_id),
      );

      if (currency_symbol) {
        setSelected_currency_id(currency_symbol.id);
        setCurrencyName(currency_symbol.currency_name);
      }
    }
  }, [isCurrencyFetched, transactions]);

  const calculateTotals = (
    dataTransaction,
    dataPayment,
    dataAddDeduct,
    expenses,
  ) => {
    const total = dataTransaction.reduce(
      (acc, transaction) => acc + (transaction?.totalAmount || 0),
      0,
    );
    // const totalpayAmount = dataPayment.reduce(
    //   (acc, pay) => acc + (pay.amount || 0),
    //   0,
    // );

    const totalpayAmount = dataPayment.reduce((acc, pay) => {
      if (pay.payment_status !== "Rejected" && pay.isDeleted !== true) {
        return acc + (pay.amount || 0);
      }
      return acc;
    }, 0);

    const floatPayAmount = floatPayment.reduce((acc, pay) => {
      if (pay.status !== "Rejected" && pay.isDeleted !== true) {
        return acc + (pay.amountInputted || 0);
      }
      return acc;
    }, 0);

    let additionaltotal = 0;
    let deductiontotal = 0;
    dataAddDeduct.forEach((adds) => {
      if (adds.type_expenses === "additional") {
        additionaltotal += parseNumber(adds.amount) * adds.rate || 0;
      } else if (adds.type_expenses === "deduction") {
        deductiontotal += parseNumber(adds.amount) * adds.rate || 0;
      }
    });

    const calculateTotalAmountExpenses = (expenses) => {
      const sumAmounts = (category) =>
        Object.values(category).reduce((sum, item) => {
          const amount = parseNumber(item.amount) || 0;
          return sum + amount;
        }, 0);

      const totalAdditional = sumAmounts(expenses.additional);
      const totalDeduction = sumAmounts(expenses.deduction);

      return { totalAdditional, totalDeduction };
    };

    const { totalAdditional, totalDeduction } =
      calculateTotalAmountExpenses(expenses);

    setExpensesTotalAmount(total);
    // setTotalPayment(totalpayAmount);
    setTotalPayment(totalpayAmount + floatPayAmount);
    setAdditionalTotalAmount(additionaltotal + totalAdditional);
    setDeductionTotalAmount(deductiontotal + totalDeduction);
  };

  // useEffect to recalculate totals when `transactions` change
  useEffect(() => {
    calculateTotals(transactions, payments, addDeducts, expenses);
  }, [transactions, payments, addDeducts, expenses, floatPayment]);

  const handleAddNewExpense = () => {
    fetchAvailableExpenses(selectedRowTransactions);

    handleShow();
  };

  const handleEditTransaction = () => {
    setIsEditing(true);
    setEdit(true);
  };

  const handleCancelEditTransaction = () => {
    swal({
      title: "Are you sure?",
      text: "Your changes will not be saved.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        const payload = JSON.stringify({ id, idToAdd: transactionToGetBack });
        const blob = new Blob([payload], { type: "application/json" });

        navigator.sendBeacon(
          `${BASE_URL}/paylocalexpenses/getBackOrderListTransaction`,
          blob,
        );

        setSelectedRow([]);
        setSelectedRowTransactions([]);
        setIsEditing(false);
        setTransactionToGetBack([]);
        setIdToAdd([]);
        setFloatPayment([]);
        setId(null);
        setEdit(false);
        window.onbeforeunload = null;
      }
    });
  };

  const [removeTransactionList, setRemoveTransactionList] = useState([]);
  const [addedTransactionsList, setAddedTransactionList] = useState([]);
  const [localExpensesData, setLocalExpensesData] = useState([]);

  let cashTotal = 0;
  let bankTotal = 0;
  let checkTotal = 0;
  let onlineTotal = 0;

  // Calculate totals
  payments.forEach((data) => {
    if (data.payment_status !== "Rejected" && data.isDeleted !== true) {
      if (data.payment_type === "Cash") {
        cashTotal += data.amount;
      } else if (data.payment_type === "Bank") {
        if (!data.check_number) {
          bankTotal += data.amount; // Bank without check number
        } else {
          checkTotal += data.amount; // Check with check number
        }
      }
      if (data.payment_type === "Bank" && data.online_ref_number) {
        onlineTotal += data.amount; // Online payment with reference number
      }
    }
  });

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const toPayAmount = expensesTotalAmount - overallDiscount;
  const sumOfAdditionalandToPay = toPayAmount + additionalTotalAmount;
  const sumOfDeductionandTotalPayment = deductionTotalAmount + totalPayment;
  let payableExpenses = sumOfAdditionalandToPay - sumOfDeductionandTotalPayment;

  const deletePayment = (arrayName, item, index) => {
    if (arrayName === "floatPayment") {
      setFloatPayment((prev) => {
        return prev.filter((_, i) => {
          return index !== i;
        });
      });
    } else {
      setPayments((prev) => {
        return prev.filter((_, i) => {
          return index !== i;
        });
      });
    }
    if (item.id) {
      setRemovePaymentListId((prev) => {
        return [...prev, item?.id];
      });
    }
    payableExpenses += item.amountInputted;
  };

  const handleApprove = () => {
    swal({
      title: "Approve this pay expenses?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (confirmed) {
        const processedPayments = payments.map((payment) => {
          return {
            id: payment.id || "",
            pay_bulk_id: payment.pay_bulk_id || "",
            account_list_sub3_id: payment.account_list_sub3_id || "",
            payment_type: payment.payment_type || "",
            check_number: payment.check_number || "",
            amount: payment.amount || "",
            date_issued: payment.date_issued || "",
            process_date: payment.process_date || "",
            transaction_number: payment.transaction_number || "",
            createdAt: payment.createdAt || "",
            updatedAt: payment.updatedAt || "",
            account_list_sub3: {
              id: payment.account_list_sub3.id || "",
              account_list_base_sub_id:
                payment.account_list_sub3.account_list_base_sub_id || "",
              account_name: payment.account_list_sub3.account_name || "",
              amount: payment.account_list_sub3.amount || "",
              currency_id: payment.account_list_sub3.currency_id || "",
              createdAt: payment.account_list_sub3.createdAt || "",
              updatedAt: payment.account_list_sub3.updatedAt || "",
            },
          };
        });
        try {
          const balance =
            expensesTotalAmount -
            overallDiscount +
            totalAdditionalExpenses -
            totalDeductionExpenses;

          // For expense journal
          const currency = currency_db.find(
            (c) => c.id === selected_currency_id,
          );

          // Awaited so a 401 (e.g. Insufficient Balance on a Management bank
          // payment) reaches the catch below
          const res = await axios.post(
            `${BASE_URL}/paylocalexpenses/bulk/approve`,
            {
              id,
              foreign_url,
              processedPayments,
              transactions_number: bulkExpenses.transaction_number,
              transaction_date: payDate
                ? format(new Date(payDate), "yyyy-MM-dd")
                : null,
              addDeducts,
              date_transacted: bulkExpenses.pay_date,
              userLoggedID,
              transactions,
              balance,
              currencyName: currency.currency_name,
              currencyRate: currency?.currency_rate,
            },
          );

          if (res.status === 201) {
            swal({
              title: "Oppss!",
              text: "Insufficient balance",
              icon: "error",
              dangerMode: true,
            });
          } else if (res.status === 200) {
            swal({
              title: "Success",
              text: "Successfully approved this request",
              icon: "success",
              timer: 2000,
            }).then(() => {
              // if (foreign_url === "local") {
              //   navigate(
              //     `/accounting/local-expenses?page=${searchParams.get(
              //       "page"
              //     )}`
              //   );
              // } else {
              //   navigate(
              //     `/accounting/overseas-expenses?page=${searchParams.get(
              //       "page"
              //     )}`
              //   );
              // }
              navigate(
                `/accounting/local-expenses?page=${searchParams.get("page")}`,
              );
            });
          } else {
            swal({
              title: "Something went wrong",
              text: "Please contact your support immediately",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            });
          }
        } catch (error) {
          if (error.response?.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            console.log(error);
            swal({
              title: "Something went wrong",
              text: "Please contact your support immediately",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            });
          }
        }
      }
    });
  };

  const handleReject = () => {
    swal({
      title: "Reject this pay expenses?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        try {
          const processedPayments = payments.map((payment) => {
            return {
              id: payment.id || "",
              pay_bulk_id: payment.pay_bulk_id || "",
              account_list_sub3_id: payment.account_list_sub3_id || "",
              payment_type: payment.payment_type || "",
              check_number: payment.check_number || "",
              amount: payment.amount || "",
              date_issued: payment.date_issued || "",
              process_date: payment.process_date || "",
              transaction_number: payment.transaction_number || "",
              createdAt: payment.createdAt || "",
              updatedAt: payment.updatedAt || "",
              account_list_sub3: {
                id: payment.account_list_sub3.id || "",
                account_list_base_sub_id:
                  payment.account_list_sub3.account_list_base_sub_id || "",
                account_name: payment.account_list_sub3.account_name || "",
                amount: payment.account_list_sub3.amount || "",
                currency_id: payment.account_list_sub3.currency_id || "",
                createdAt: payment.account_list_sub3.createdAt || "",
                updatedAt: payment.account_list_sub3.updatedAt || "",
              },
            };
          });

          axios
            .post(`${BASE_URL}/paylocalexpenses/rejected`, null, {
              params: {
                id,
                transactions,
                userLoggedID,
                foreign_url,
                transaction_number: bulkExpenses.transaction_number,
                date: bulkExpenses.pay_date,
                processedPayments,
              },
            })
            .then((res) => {
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Successfully rejected this request",
                  icon: "success",

                  dangerMode: true,
                }).then(() => {
                  // if (foreign_url === "local") {
                  //   navigate(
                  //     `/accounting/local-expenses?page=${searchParams.get(
                  //       "page"
                  //     )}`
                  //   );
                  // } else {
                  //   navigate(
                  //     `/accounting/overseas-expenses?page=${searchParams.get(
                  //       "page"
                  //     )}`
                  //   );
                  // }
                  navigate(
                    `/accounting/local-expenses?page=${searchParams.get(
                      "page",
                    )}`,
                  );
                });
              } else {
                swal({
                  title: "Something went wrong",
                  text: "Please contact your support immediately",
                  icon: "warning",
                  buttons: true,
                  dangerMode: true,
                });
              }
            });
        } catch (error) {
          if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            console.log(error);
            swal({
              title: "Something went wrong",
              text: "Please contact your support immediately",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            });
          }
        }
      }
    });
  };

  const totalAdditionalExpenses = addDeducts
    .filter((data) => data.type_expenses === "additional")
    .reduce((acc, curr) => acc + (curr.amount || 0), 0);

  const totalDeductionExpenses = addDeducts
    .filter((data) => data.type_expenses === "deduction")
    .reduce((acc, curr) => acc + (curr.amount || 0), 0);

  const handleUpdate = () => {
    // Filter out the transactions that are marked for removal
    const filteredTransactions = transactions.filter(
      (transaction) => !transaction.toBeRemoved,
    );

    if (!payDate) {
      swal({
        title: "Required Field Missing",
        text: "Please ensure Processed Date is filled out.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
      return;
    }

    const totalAdditionalExpenses_forUpdate = addDeducts
      .filter((data) => data.type_expenses === "additional")
      .reduce((acc, curr) => acc + (curr.amount || 0), 0);

    const totalDeductionExpenses_forUpdate = addDeducts
      .filter((data) => data.type_expenses === "deduction")
      .reduce((acc, curr) => acc + (curr.amount || 0), 0);

    swal({
      title: "Do you want to update this transaction?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        try {
          const expensesToSubmit = [];

          // additional expenses
          for (const expense of Object.values(expenses.additional)) {
            expensesToSubmit.push({
              subject1: expense.subject1,
              subject2: expense.subject2,
              subject3: expense.subject3,
              remarks: expense.remarks,
              amount: parseFloat(String(expense.amount).replace(/,/g, "")) || 0,
              payment_method: expense.payment_method,
              type: "additional",
              LoanORAccount: expense.LoanORAccount,
              rate: expense.rate,
              expensesTotalAmount,
            });
          }

          // deduction expenses
          for (const expense of Object.values(expenses.deduction)) {
            expensesToSubmit.push({
              subject1: expense.subject1,
              subject2: expense.subject2,
              subject3: expense.subject3,
              remarks: expense.remarks,
              amount: parseFloat(String(expense.amount).replace(/,/g, "")) || 0,
              payment_method: expense.payment_method,
              type: "deduction",
              LoanORAccount: "account",
              rate: expense.rate,
            });
          }

          axios
            .post(`${BASE_URL}/paylocalexpenses/update`, null, {
              params: {
                id,
                // transactions: filteredTransactions,
                transactions: filteredTransactions.map((t) => ({
                  id: t.id,
                  totalAmount: t.totalAmount,
                  expensesDiscountType: t.expensesDiscountType,
                  expensesDiscountValue: t.expensesDiscountValue,
                  expensesDiscountOperator: t.expensesDiscountOperator,
                })),
                payDate,
                removedIds: [...new Set(removeTransactionList)],
                floatPayment,
                expenses: expensesToSubmit,
                userLoggedID,
                foreign_url,
                removePaymentListId: [...new Set(removePaymentListId)],
                // totalAmountSum: parseFloat(
                //   expensesTotalAmount +
                //     totalAdditionalExpenses_forUpdate -
                //     totalDeductionExpenses_forUpdate,
                // ),
                totalAmountSum: parseFloat(
                  expensesTotalAmount - overallDiscount,
                ),
                overallDiscount: overallDiscount,
                currencyRate,
              },
            })
            .then((res) => {
              // setIsEditing(false);
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Successfully updated the transaction",
                  icon: "success",
                  dangerMode: true,
                }).then(() => {
                  resetExpenses();
                  // reloadTableBelow();
                  setIsCutoffPosted(res.data.isPosted);
                  setIsEditing(false);
                  setFloatPayment([]);
                  setSelectedRow([]);
                  setSelectedRowTransactions([]);
                  setTransactionToGetBack([]);
                  setIdToAdd([]);
                  setId(null);
                  setEdit(false);
                  window.onbeforeunload = null;
                });
              } else {
                swal({
                  title: "Something went wrong",
                  text: "Please contact support immediately",
                  icon: "warning",
                  buttons: true,
                  dangerMode: true,
                });
              }
            });
        } catch (error) {
          console.error("Error updating transaction:", error);
          swal({
            title: "Something went wrong",
            text: "Please contact support immediately",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          });
        }
      }
    });
  };

  const handleAddTransaction = (index, selectedId) => {
    // Find the selected transaction details from localExpensesData
    const selectedTransaction = localExpensesData.find(
      (data) => String(data.id) === String(selectedId),
    );

    if (!selectedTransaction) {
      console.error("Selected transaction not found");
      return;
    }

    // Check if data and data.id exist in selectedTransaction
    const selectedTransactionId =
      selectedTransaction.data?.id || selectedTransaction.id;

    setAddedTransactionList((prevList) => [
      ...prevList,
      selectedTransactionId, // Ensure correct reference
    ]);

    // Update the transaction if it exists in localExpensesData
    if (selectedTransaction) {
      // Create a new transaction item based on selectedTransaction details
      const newTransaction = {
        expense: {
          transaction_id: selectedTransaction.transaction_id,
          expenses_date: selectedTransaction.expenses_date,
          totalAmount: selectedTransaction.totalAmount,
          expenses2: selectedTransaction.expenses2,
          desc: selectedTransaction.desc,
        },
        newExpense: false,
      };

      // Insert the new transaction into transactions at the specified index
      const updatedTransactions = [...transactions];
      updatedTransactions[index] = newTransaction;

      // Update the transactions state
      setTransactions(updatedTransactions);
    }
  };

  // **********************************************Payment Method*****************************************//
  const [validated, setValidated] = useState(false);

  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [subject3, setSubject3] = useState("");
  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState("Bank");
  const [onlinePaymentCheckbox, setOnlinePaymentCheckbox] = useState(false);
  const [bankAmount, setBankAmount] = useState(0);
  const [checkNumber, setCheckNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amountInputted, setAmountInputted] = useState(""); //amount 'to sa payment method
  const [onlineWalletRemarks, setOnlineWalletRemarks] = useState("");
  // const [floatPayment, setFloatPayment] = useState([]);
  const [date, setDate] = useState("");
  const [processDate, setProcessDate] = useState("");
  const [totalAmountSum, setTotalAmountSum] = useState(0);
  const payableBalance =
    expensesTotalAmount +
    totalAdditionalExpenses -
    totalDeductionExpenses -
    totalPayment;
  const isInputDisabled =
    !payDate ||
    parseFloat(payableBalance) === 0 ||
    parseFloat(payableExpenses) <= 0 ||
    (parseFloat(payableBalance) === 0 && !isEditing) ||
    (status === "For-Approval" && !isEditing) ||
    status === "Rejected";

  // Subject 2 Payment Method Options for dropdown select
  const subject2Options = subject2DataList?.map((item) => {
    return {
      value: item.id,
      label: item.subject_name,
      subject_type: item.subject_type,
    };
  });

  // Subject 3 Payment Method Options for dropdown select
  const subject3Options = subject3DataList.map((item) => {
    return {
      value: item.id,
      label: item.account_name,
    };
  });

  useEffect(() => {
    if (amountInputted) {
      handleAmountValue(amountInputted);
    }
  }, [date]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchAvailableExpenses(selectedRowTransactions);
    }, 500);

    return () => {
      clearTimeout(delayDebounce);
    };
  }, [searchTerm]);

  useEffect(() => {
    setSearchTerm("");
  }, [filterColumn]);

  const handleAddPayment = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    // let formatAmountInputted = String(amountInputted).replace(/,/g, "");
    const formatAmount = parseFloat(amountInputted);

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill the red text fields",
        buttons: false,
        timer: 2000,
      });
    } else {
      if (formatAmount <= 0) {
        swal({
          icon: "error",
          title: "Amount Required",
          text: "The amount cannot be zero. Please enter a valid value.",
          buttons: "OK",
        });
        return;
      }

      if (formatAmount > payableExpenses) {
        swal({
          icon: "error",
          title: "Oppss!",
          text: `Amount cannot exceed the payable balance of [${payableExpenses.toLocaleString(
            "en-US",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          )}]`,
          buttons: false,
          timer: 2000,
        });
        return; /// return that will react when the amount is higher then payable expenses
      }

      const successMessage = () => {
        swal({
          icon: "success",
          title: "Payment Added",
          text: "The new payment has been added successfully",
          buttons: false,
          timer: 2000,
        }).then(() => {
          clearPaymentFields();
        });
      };

      if (
        selectedPayment === "Bank" &&
        checkNumber &&
        !(await validateCheckNumbers(checkNumber, {
          pending: floatPayment
            .filter((payment) => !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      swal({
        title: "Add this new payment?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmed) => {
        if (confirmed) {
          const isForApproval = status === "For-Approval";
          const pIteration = payments.length + floatPayment.length + 1;
          const generatedTransactionNumber = `${bulkExpenses.transaction_number}_p${pIteration}`;
          const newPayment = {
            paymentMethod: selectedPayment,
            transaction_number: generatedTransactionNumber,
            subject1: subject1,
            subject2: subject2?.value,
            subject3: subject3?.value,
            accountName: accountName,
            amountInputted: formatAmount,
            issuedDate: date,
            processDate: payDate,
            checkNumber: checkNumber,
            refNumber: refNumber,
            remarks: onlineWalletRemarks,
          };

          // Handle payment for pending transactions
          if (isForApproval) {
            setFloatPayment((prevPayments) => [...prevPayments, newPayment]);
            setTotalPayment((prevTotal) => prevTotal + formatAmount);
            successMessage();
          }

          // Handle payment for approved transactions
          if (!isForApproval) {
            try {
              const res = await axios.post(
                `${BASE_URL}/paylocalexpenses/bulk/payments`,
                {
                  newPayment,
                  payBulkId: id,
                  userLoggedID,
                },
              );

              if (res.status === 200) {
                successMessage();
                reloadTableBelow();
              }
            } catch (error) {
              console.error(error);
            }
          }
        }
      });
    }
    setValidated(true);
  };

  const clearPaymentFields = () => {
    setValidated(false);
    setOnlinePaymentCheckbox(false);

    setRefNumber("");
    setOnlineWalletRemarks("");
    // setSelectedPayment("Bank");
    setAccountName("");
    setAmountInputted("");
    setCheckNumber("");
    setRefNumber("");
    setDate("");
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  const handlePaymentMethod = (e) => {
    const paymentMethod = e.target.value;
    setSelectedPayment(paymentMethod);
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
  };

  const handleOnlineCheck = (e) => {
    setOnlinePaymentCheckbox(e.target.checked);
  };

  const handleAccountChange = (selectedOption) => {
    const selectedAccountId = selectedOption?.value;
    setSubject3(selectedOption);

    // Reset first so the balance clears immediately if the selection is
    // cleared or doesn't match a known account.
    setBankAmount(0);
    setAccountName("");

    const selectedAccount = subject3DataList.find(
      (account) => String(account.id) === String(selectedAccountId),
    );

    if (selectedAccount) {
      setBankAmount(selectedAccount.amount);
      setAccountName(selectedAccount.account_name);
      setAmountInputted(payableExpenses.toFixed(2).toString());
    }
  };

  const handleSubject1Change = (event) => {
    const selectedSubject1 = event.target.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      account_selected = "Owner's Equity Account";
    }

    // Reset downstream selections and the account balance immediately,
    // so they clear the moment Subject 1 changes instead of depending on
    // the Subject 2 fetch below.
    setSubject2("");
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);

    try {
      axios
        .get(`${BASE_URL}/paylocalexpenses/getSubject1LocalExpenses`, {
          params: {
            account_selected: account_selected,
            selectedPayment,
          },
        })
        .then((res) => {
          setSubject1(selectedSubject1);
          setIsSubject2Disabled(false); // Enable Subject 2 after Subject 1 selection
          setSubject2DataList(res.data); //retrieve subject 2 data
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleSubject2Change = (selectedOption) => {
    const selectedSubject2 = selectedOption;

    // Reset the account selection and balance immediately when Subject 2
    // changes.
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
    setIsSubject3Disabled(true);

    try {
      axios
        .get(`${BASE_URL}/paylocalexpenses/getSubject3LocalExpenses`, {
          params: {
            subjectId: selectedSubject2?.value,
            totalAmountSum,
            selected_currency_id,
          },
        })
        .then((res) => {
          console.log(
            "9******************************************selectedSubject2: ",
            selectedSubject2,
          );
          setSubject3DataList(res.data);
          console.log(res.data);
          setSubject2(selectedSubject2);
          setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  // const onInputFloat = (e) => {
  //   e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  // };

  // const handleAmountValue = (value) => {
  //   if (value == ".") {
  //     setAmountInputted((prev) => prev + ".");
  //   }
  //   let inputValue = value.replace(/[^0-9.]/g, "");

  //   let [integerPart, decimalPart] = inputValue.split(".");

  //   if (integerPart) {
  //     integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }

  //   let formattedValue =
  //     decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
  //   const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

  //   let formatAmount = inputValue.replace(/,/g, "");
  //   // Convert to number and format with commas
  //   let numericValue = parseFloat(formatAmount);

  //   // Check if the input value is greater than the totalAmountSum
  //   if (numericValue > payableExpenses && date <= currentDate) {
  //     swal({
  //       title: "Oppss!",
  //       text: "Please input not greater than the balance",
  //       icon: "error",
  //       buttons: false,
  //       timer: 2000,
  //       dangerMode: true,
  //     }).then(() => {
  //       setAmountInputted(0);
  //     });
  //   } else {
  //     setAmountInputted(cleanedValue);
  //   }
  // };

  const handleAmountValue = (val) => {
    if (val === "" || val === ".") {
      setAmountInputted(val);
      return;
    }

    const numericValue = parseFloat(val);
    const formatBankAmount = parseNumber(bankAmount);
    const isLiability = subject1 === "Liabilities Account";

    const balance_now = payableExpenses;

    let maxAllowedAmount = balance_now;
    let triggeredBy = "expense_balance";

    if (!isLiability && formatBankAmount < balance_now) {
      maxAllowedAmount = formatBankAmount;
      triggeredBy = "account_balance";
    }

    if (numericValue > maxAllowedAmount) {
      if (triggeredBy === "account_balance") {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text: `Please input not greater than the account balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`,
          buttons: false,
          timer: 2000,
        });
      } else {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text: `Please input not greater than the balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`,
          buttons: false,
          timer: 2000,
        });
      }
      setAmountInputted(maxAllowedAmount.toFixed(2).toString());
      return;
    }

    setAmountInputted(val);
  };

  const handleAdditionalExpenses = (type) => {
    const newRowId = Object.keys(expenses[type]).length;
    setExpenses((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [newRowId]: {
          subject1: "",
          subject2: "",
          subject3: "",
          payment_method: "",
          remarks: "",
          check: "",
          amount: "",
          subject2Options: [],
          subject3Options: [],
          type: type,
          disabledSubject2: true,
          disabledSubject3: true,
          disabledAmount: true,
          rate: "",
        },
      },
    }));
  };

  const renderExpenseTable = (type) => {
    // Subject 1 Options for dropdown select
    const subject1AddDeductOptions = [
      "Account-List",
      "Liabilities Account",
      "Asset Account",
      "Owner's Equity Account",
    ].map((item) => ({
      value: item,
      label: item,
    }));

    // Subject 2 Options for dropdown select
    const subject2AddDeductOptions = (row) =>
      row.subject2Options.map((data) => ({
        value: data.id,
        label: data.subject_name,
      }));

    // Subject 3 Options for dropdown select
    const subject3AddDeductOptions = (row) =>
      row.subject3Options.map((data) =>
        row.subject1 === "Loan_Unique"
          ? {
              value: data.id,
              label: data.loan_name,
            }
          : { value: data.id, label: data.account_name },
      );

    // <Table bordered hover>
    return (
      <tbody>
        {Object.entries(expenses[type]).map(([rowId, row]) => (
          <tr key={rowId}>
            <td>
              <Select
                options={subject1AddDeductOptions}
                value={subject1AddDeductOptions.find(
                  (item) => item?.value === row.subject1,
                )}
                onChange={(selectedOption) =>
                  handleSubject1AddDeductExpensesChange(
                    rowId,
                    selectedOption?.value,
                    type,
                  )
                }
                menuPortalTarget={document.body}
                placeholder={`Select Subject 1`}
                styles={selectCustomStyles(row.subject1)}
                required
              />
            </td>
            <td>
              <Select
                options={subject2AddDeductOptions(row)}
                value={subject2AddDeductOptions(row).find(
                  (item) => item?.value === row.subject2,
                )}
                onChange={(selectedOption) =>
                  handleSubject2AddDeductExpensesChange(
                    rowId,
                    selectedOption?.value,
                    type,
                  )
                }
                menuPortalTarget={document.body}
                placeholder={`Select Subject 2`}
                styles={selectCustomStyles(row.subject2)}
                isDisabled={row.disabledSubject2}
                required
              />
            </td>
            <td>
              <Select
                options={subject3AddDeductOptions(row)}
                value={subject3AddDeductOptions(row).find(
                  (item) => item?.value === row.subject3,
                )}
                onChange={(selectedOption) => {
                  const selectedValue = selectedOption?.value;

                  const selectedOptions = row.subject3Options.find(
                    (option) => option.id == selectedValue,
                  );

                  const currAmount = selectedOptions?.amount || 0;

                  handleSubject3AddExpensesChange(
                    rowId,
                    selectedValue,
                    type,
                    row.subject1 === "Loan_Unique" ? "loan" : "account",
                    currAmount,
                  );
                }}
                menuPortalTarget={document.body}
                isDisabled={row.disabledSubject3}
                placeholder={`Select Subject 3`}
                styles={selectCustomStyles(row.subject3)}
                required
              />
            </td>
            <td>
              <Form.Control
                type="text"
                value={row.remarks}
                onChange={(e) =>
                  handleRemarksChange(rowId, e.target.value, type)
                }
                placeholder="Description ..."
              />
            </td>
            <td>
              <Form.Control
                type="text"
                value={row.amount}
                onChange={(e) =>
                  handleAmountChange(rowId, e.target.value, type)
                }
                placeholder="0.00"
                required
                disabled={row.disabledAmount}
              />
            </td>
            {selected_currency_id ===
            "11111111-1111-1111-1111-111111111111" ? null : (
              <>
                <td>
                  <Form.Control
                    type="text"
                    value={row.rate}
                    onChange={(e) =>
                      handleRateChange(rowId, e.target.value, type)
                    }
                    placeholder="0.00"
                    required
                    disabled={row.disabledAmount}
                  />
                </td>
              </>
            )}
            <td>
              <Button
                variant="danger"
                onClick={() => handleRemoveRow(rowId, type)}
                disabled={rowId === "0"}
              >
                Remove
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    );
    // </Table>
  };

  const resetExpenses = () => {
    setExpenses({
      additional: {
        0: {
          subject1: "",
          subject2: "",
          subject3: "",
          payment_method: "",
          remarks: "",
          check: "",
          amount: "",
          subject2Options: [],
          subject3Options: [],
          type: "additional",
          disabledSubject2: true,
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
      deduction: {
        0: {
          subject1: "",
          subject2: "",
          subject3: "",
          payment_method: "",
          remarks: "",
          check: "",
          amount: "",
          subject2Options: [],
          subject3Options: [],
          type: "deduction",
          disabledSubject2: true,
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
    });
  };

  const dateValidation = async (selectedDate) => {
    try {
      const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
        params: {
          date: selectedDate,
        },
      });
      // if (res.data == false) {
      //   swal({
      //     icon: "error",
      //     title: `Invalid ${dateLabel}`,
      //     text: `Please Create Cutoff for this Date (${format(
      //       selectedDate,
      //       "MMM/dd/yyyy"
      //     )})`,
      //   }).then(() => {
      //     clearField("");
      //   });
      // }
    } catch (error) {
      console.error(error);
    }
  };

  if (isEditing === true) {
    window.onbeforeunload = (e) => {
      e.preventDefault();
      const payload = JSON.stringify({ id, idToAdd: transactionToGetBack });
      const blob = new Blob([payload], { type: "application/json" });

      navigator.sendBeacon(
        `${BASE_URL}/paylocalexpenses/getBackOrderListTransaction`,
        blob,
      );

      setIsEditing(false);
      window.onbeforeunload = null;
      return "";
    };
  }

  // function to handle currency rate formatting
  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const handleItemDiscountChange = (index, key, value) => {
    setTransactions((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [key]: value,
      };
      return updated;
    });
  };

  useEffect(() => {
    let grossAmount = 0;
    let totalDiscount = 0;

    transactions.forEach((item) => {
      const amount = parseFloat(item.totalAmount) || 0;
      grossAmount += amount;

      let itemDiscount = 0;
      const discVal = parseFloat(item.expensesDiscountValue) || 0;

      if (item.expensesDiscountType === "amount") {
        itemDiscount = discVal;
      } else {
        itemDiscount = (discVal / 100) * amount;
      }

      if (item.expensesDiscountOperator === "-") {
        totalDiscount -= itemDiscount;
      } else {
        totalDiscount += itemDiscount;
      }
    });

    setOverallDiscount(totalDiscount);
  }, [transactions]);

  useEffect(() => {
    if (selectedPayment === "Cash") {
      if (payDate) {
        // Sync maturity date with the chosen process date
        setDate(payDate);
      } else {
        // Fallback to today if no date is picked
        const currentDate = dateToday();
        setPayDate(currentDate);
        setDate(currentDate);
      }
      setIsAmountDisabled(false);
    }
  }, [selectedPayment, payDate]);

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="w-100 p-2 d-flex flex-row justify-content-between">
        <div className="w-100 d-flex flex-row justify-content-between">
          <span className="fs-3">
            <Link
              to={`${`/accounting/local-expenses?page=${searchParams.get(
                "page",
              )}`}`}
              className="text-dark me-2"
            >
              <i class="fa-solid fa-arrow-left"></i>
            </Link>
            NEW {foreignExpenses} EXPENSES DETAILS
            <p className="fs-6">
              Status:{" "}
              <span
                style={{
                  color:
                    bulkExpenses.status === "For Approval"
                      ? "orange"
                      : bulkExpenses.status === "Approved"
                        ? "green"
                        : "red",
                  bulkExpenses: "uppercase",
                }}
              >
                {bulkExpenses.status}
              </span>
            </p>
          </span>
        </div>
      </div>

      <Container fluid>
        <Row className="p-2">
          <Col sm>
            <span>Transaction Number</span>
            <Form.Control
              type="text"
              className=" p-2"
              value={bulkExpenses.transaction_number || ""}
              readOnly
            />
          </Col>
          <Col sm>
            <span>Processed Date</span>
            <InputGroup>
              <CustomDatePicker
                label={"Pay Date"}
                selected={payDate ? new Date(payDate) : ""}
                handleDateChange={(selectedDate) => {
                  if (!selectedDate) {
                    setPayDate(null);
                    return;
                  }
                  const toDateOnly = (d) => {
                    const r = new Date(d);
                    r.setHours(0, 0, 0, 0);
                    return r;
                  };
                  if (date && toDateOnly(selectedDate) > toDateOnly(date)) {
                    swal({
                      icon: "warning",
                      title: "Invalid Process Date",
                      text: "Process Date cannot be greater than the Maturity Date.",
                      buttons: false,
                      timer: 2500,
                    });
                    return;
                  }
                  setPayDate(selectedDate);
                  // Replaced by checkCutoffDate (utils/cutoffDateValidation)
                  // dateValidation(selectedDate);
                  // postedCutoffValidation(selectedDate, setPayDate, "Processed Date");
                  warnCutoffDate(selectedDate, setPayDate, "Processed Date");
                }}
                setter={setPayDate}
                CustomInput={CustomInput}
                isRequired={true}
                validated={validated}
                disabled={
                  !(
                    isEditing ||
                    status === "Approved" ||
                    status === "Partially-Paid"
                  )
                }
                // "Today" button
                dateValidation={(today) =>
                  warnCutoffDate(today, setPayDate, "Processed Date")
                }
                maxDate={
                  date
                    ? new Date(new Date(date).setHours(23, 59, 59, 999))
                    : undefined
                }
              />
              {bulkExpenses.status !== "For-Approval" && (
                <InputGroup.Text
                  className="cursor-pointer"
                  onClick={() => setShowHistoryModal(true)}
                  title="View Payment History"
                >
                  <i className="fas fa-history"></i>
                </InputGroup.Text>
              )}
            </InputGroup>
            <ExpensesHistoryModal
              show={showHistoryModal}
              onHide={() => setShowHistoryModal(false)}
              expensesId={id}
            />
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>
              Currency <span className="text-danger">*</span>
              {/* {selected_currency_id &&
              selected_currency_id !==
                "11111111-1111-1111-1111-111111111111" ? (
                <span className="text-muted mb-1">
                  {" "}
                  Current Rate: {currencyRate}
                </span>
              ) : null} */}
            </span>
            <Form.Select
              required
              onChange={(e) => handleCurrencyChange(e.target.value)}
              className="p-2"
              value={selected_currency_id}
              disabled
            >
              <option value="" selected disabled>
                Select Currency
              </option>
              {currency_db.map((data) => (
                <option key={data.id} value={data.id}>
                  {`${data.currency_name}`}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col sm>
            <span>Balance</span>
            <InputGroup>
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2"
                placeholder="0.00"
                value={formatToTwoDecimal(
                  expensesTotalAmount +
                    totalAdditionalExpenses -
                    totalDeductionExpenses,
                )}
                readOnly
              />
            </InputGroup>
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>Overall Expenses Discount</span>
            <InputGroup>
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2 pointer-events-none"
                id="overallDiscountAmount"
                value={formatToTwoDecimal(overallDiscount)}
                readOnly
              />
            </InputGroup>
          </Col>
          <Col sm>
            {selected_currency_id &&
            selected_currency_id !== "11111111-1111-1111-1111-111111111111" ? (
              <div className="d-none">
                <span>
                  Currency Rate<span className="text-danger">*</span>
                </span>
                <Form.Control
                  type="text"
                  className="p-2"
                  required
                  onChange={handleCurrencyRateChange}
                  value={currencyRate}
                  disabled={!isEditing}
                />
              </div>
            ) : null}
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Expenses List</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-2 p-2 new-item-custom scrollable-contents">
          <Table bordered hover responsive className="fixed-inputs-table">
            <thead className="table-light">
              <tr>
                <th className="p-2">Transaction ID</th>
                <th className="p-2">Remarks</th>
                <th className="p-2">Expenses Type</th>
                <th className="p-2">Expenses Date</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Expenses Discount</th>
                {/* <th className="p-2">Description</th> */}
                {isEditing && <th className="p-2">Action</th>}
              </tr>
            </thead>
            {transactions.length > 0 ? (
              <tbody>
                {transactions.map((t, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Control
                        className="d-none"
                        value={t?.transaction_id || "---"}
                        type="text"
                        readOnly
                      />
                      <Form.Control
                        value={t?.client_transaction_id || "---"}
                        type="text"
                        readOnly
                      />
                    </td>
                    <td>
                      {t.newExpense ? (
                        <Form.Select
                          size="sm"
                          required
                          className="p-2"
                          onChange={(e) =>
                            handleAddTransaction(index, e.target.value)
                          }
                        >
                          <option selected disabled>
                            Select Remarks
                          </option>
                          {localExpensesData.map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.desc}
                            </option>
                          ))}
                        </Form.Select>
                      ) : (
                        <Form.Control
                          className="p-2"
                          type="text"
                          size="sm"
                          value={t?.desc}
                          readOnly
                        />
                      )}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        size="sm"
                        className="p-2"
                        readOnly
                        value={`${t?.expenses2.expenses_one.expenses_type_one} - ${t?.expenses2.sub_type}`}
                      />
                    </td>
                    <td>
                      {/* <input
                        type="date"
                        className="form-control form-control-sm p-2"
                        readOnly
                        value={t?.expenses_date}
                      /> */}
                      <DatePicker
                        selected={t?.expenses_date}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control form-control-sm p-2"
                        readOnly
                      />
                    </td>
                    <td>
                      <InputGroup>
                        <InputGroup.Text>
                          {currencySymbol[currencyName] || ""}
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          size="sm"
                          className="p-2"
                          value={formatToTwoDecimal(t?.totalAmount)}
                          readOnly
                        />
                      </InputGroup>
                    </td>
                    <td>
                      <InputGroup>
                        <Button
                          type="button"
                          variant="primary"
                          id={`discount-type-${index}`}
                          title={
                            t.expensesDiscountType === "percent"
                              ? "Discount type: Percentage (%). Click to switch to Fixed Amount"
                              : "Discount type: Fixed Amount. Click to switch to Percentage (%)"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          disabled={!isEditing || !selected_currency_id}
                          onClick={() => {
                            if (!selected_currency_id || !isEditing) return;
                            const newType =
                              t.expensesDiscountType === "percent"
                                ? "amount"
                                : "percent";
                            let newValue = t.expensesDiscountValue;

                            if (
                              newType === "percent" &&
                              parseFloat(newValue) >= 100
                            ) {
                              newValue = 100;
                            }

                            setTransactions((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                ...updated[index],
                                expensesDiscountType: newType,
                                expensesDiscountValue: newValue,
                              };
                              return updated;
                            });
                          }}
                        >
                          {t.expensesDiscountType === "percent"
                            ? "%"
                            : currencySymbol[currencyName] || ""}
                        </Button>
                        <NumberInDecimals
                          className="form-control p-2"
                          disabled={!isEditing || !selected_currency_id}
                          value={t.expensesDiscountValue || ""}
                          placeholder="0.00"
                          decimals={2}
                          max={
                            t.expensesDiscountType === "percent"
                              ? 100
                              : parseFloat(t.totalAmount)
                          }
                          onChange={(val) => {
                            handleItemDiscountChange(
                              index,
                              "expensesDiscountValue",
                              val,
                            );
                          }}
                        />
                        <Button
                          type="button"
                          id={`discount-operator-${index}`}
                          variant="primary"
                          title={
                            t.expensesDiscountOperator === "+"
                              ? "Operator: Adding discount (+). Click to subtract instead"
                              : "Operator: Subtracting discount (−). Click to add instead"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          disabled={!isEditing || !selected_currency_id}
                          onClick={() => {
                            if (!selected_currency_id || !isEditing) return;
                            const newOp =
                              t.expensesDiscountOperator === "+" ? "-" : "+";
                            handleItemDiscountChange(
                              index,
                              "expensesDiscountOperator",
                              newOp,
                            );
                          }}
                        >
                          {t.expensesDiscountOperator || "+"}
                        </Button>
                      </InputGroup>
                    </td>
                    {/* <td className="text-center">
                      <Form.Control
                        type="text"
                        size="sm"
                        className="p-2"
                        value={t?.desc || "n/a"}
                        readOnly
                      />
                    </td> */}

                    {isEditing && (
                      <td>
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() => deleteItem(t, index)}
                          disabled={
                            transactions.length <= 1 ||
                            (transactions.length > 1 && !transactions[1]?.id)
                          }
                        >
                          Remove
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <caption className="text-center mt-3">
                There are no records to display
              </caption>
            )}
          </Table>
        </div>
        <div className="w-100 d-flex justify-content-end mt-2">
          {isEditing && (
            <Button
              size="sm"
              variant="primary"
              type="button"
              onClick={handleAddNewExpense}
            >
              Add Expenses
            </Button>
          )}
        </div>
        <Modal
          show={show}
          size="xl"
          onHide={() => {
            setFilterColumn("all");
            setSearchTerm("");
            handleClose();
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Expenses Lists</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => {
                    let input = e.target.value;

                    // Remove commas
                    const raw = String(input).replace(/,/g, "");

                    const [intPart, decimalPart] = raw.split(".");

                    // Add commas to integer part
                    const withCommas = intPart.replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ",",
                    );

                    // Join back decimal part if it exists
                    const formatted =
                      decimalPart !== undefined
                        ? `${withCommas}.${decimalPart}`
                        : withCommas;

                    if (
                      localExpensesData.find(
                        (item) =>
                          Number(item.totalAmount.toPrecision(17))
                            .toString()
                            .includes(raw) ||
                          item.totalAmount.toFixed(17).includes(raw),
                      )
                    ) {
                      setSearchTerm(formatted);
                    } else {
                      setSearchTerm(raw);
                    }
                  }}
                />
                <Dropdown align="end">
                  <Dropdown.Toggle variant="primary" id="dropdown-search">
                    <i className="fa-solid fa-sliders me-2" />
                    {dropdownFilters.find((opt) => opt.value === filterColumn)
                      ?.label || "Filter"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {dropdownFilters.map(({ value, label }) => (
                      <Dropdown.Item
                        key={value}
                        active={filterColumn === value}
                        onClick={() => setFilterColumn(value)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </InputGroup>
            </Row>
            <DataTable
              columns={columns}
              data={localExpensesData}
              customStyles={customStyles}
              className="dataTable"
              onRowClicked={(row) =>
                handleIndividualCheckBoxChange(row.transaction_id)
              }
            />
            <PaginationControls {...pagination} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setFilterColumn("all");
                setSearchTerm("");
                handleClose();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={submitModal}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
      <Container fluid className="mt-4">
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Payment</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-4">
          <Row className="w-100 p-2 mt-1">
            <Col xs={12} md={4} className="p-2">
              <div className="w-100 border shadow-sm p-3 rounded">
                <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                  <span className="fw-bold">Payment Method</span>
                  {!payDate && (
                    <small className="text-danger mt-1">
                      Please select a Processed Date to continue.
                    </small>
                  )}
                </div>
                <Form validated={validated} onSubmit={handleAddPayment}>
                  <Form.Group className="mb-3" controlId="payWith">
                    <Form.Label className="fw-bold">Pay With:</Form.Label>
                    <div className="d-flex">
                      <Form.Check
                        type="radio"
                        name="paymentType"
                        id="bank"
                        label="Bank"
                        value="Bank"
                        checked={selectedPayment === "Bank"}
                        onChange={handlePaymentMethod}
                        disabled={isInputDisabled}
                        className="me-3"
                      />
                      <Form.Check
                        type="radio"
                        name="paymentType"
                        id="cash"
                        label="Cash"
                        value="Cash"
                        checked={selectedPayment === "Cash"}
                        onChange={handlePaymentMethod}
                        disabled={isInputDisabled}
                        className="me-3"
                      />
                    </div>
                    {/* <div className="mt-2">
                      <input
                        type="checkbox"
                        disabled={isInputDisabled}
                        checked={onlinePaymentCheckbox}
                        onChange={handleOnlineCheck}
                      />{" "}
                      <label>Online</label>
                    </div> */}
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Subject 1</Form.Label>
                    <Form.Select
                      className="form-select"
                      onChange={handleSubject1Change}
                      value={subject1}
                      disabled={isInputDisabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Subject 1
                      </option>
                      <option value="Account-List">Account-List</option>
                      <option value="Asset Account">Asset Account</option>
                      <option value="Liabilities Account">
                        Liabilities Account
                      </option>
                      <option value="Owner's Equity Account">
                        Owner's Equity Account
                      </option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Subject 2</Form.Label>
                    <Select
                      options={subject2Options}
                      value={subject2}
                      onChange={handleSubject2Change}
                      onMenuOpen={() => {
                        if (subject2DataList.length === 0) {
                          swal({
                            icon: "warning",
                            title: "Warning",
                            text: "No Subject 2 found. Please create a Subject 2 account first.",
                          });
                          return;
                        }
                      }}
                      menuIsOpen={
                        subject2DataList?.length === 0 ? false : undefined
                      }
                      isDisabled={isSubject2Disabled}
                      placeholder={`Select Subject 2`}
                      styles={selectCustomStyles(subject2, validated)}
                      required
                      isSearchable
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="accountName">
                    <Form.Label className="fw-bold">Accounts</Form.Label>
                    <Select
                      options={subject3Options}
                      value={subject3}
                      onChange={handleAccountChange}
                      onMenuOpen={() => {
                        if (subject3DataList.length === 0) {
                          swal({
                            icon: "warning",
                            title: "Warning",
                            text: "No Subject 3 found. Please create a Subject 3 account first.",
                          });
                          return;
                        }
                      }}
                      menuIsOpen={
                        subject3DataList.length === 0 ? false : undefined
                      }
                      isDisabled={isSubject3Disabled}
                      placeholder={`Select Account name`}
                      styles={selectCustomStyles(subject3, validated)}
                      required={selectedPayment !== "Online"}
                      isSearchable
                    />
                  </Form.Group>

                  {selectedPayment === "Bank" && !onlinePaymentCheckbox && (
                    <Form.Group className="mb-3" controlId="checkNumber">
                      <Form.Label>Check #</Form.Label>
                      <Form.Control
                        type="text"
                        className="p-2"
                        disabled={isInputDisabled}
                        placeholder="000000-000-0000"
                        value={checkNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          setCheckNumber(value);
                        }}
                      />
                      <CheckNumberError
                        value={checkNumber}
                        disabled={selectedPayment !== "Bank"}
                        pending={floatPayment
                          .filter((payment) => !payment.isDeleted)
                          .map((payment) => payment.checkNumber)}
                      />
                    </Form.Group>
                  )}

                  {/* {onlinePaymentCheckbox && (
                    <Form.Group className="mb-3" controlId="checkNumber">
                      <Form.Label>Reference #</Form.Label>
                      <Form.Control
                        type="text"
                        className="p-2"
                        disabled={isInputDisabled}
                        placeholder="000000-000-0000"
                        value={refNumber}
                        onChange={(e) => setRefNumber(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  {onlinePaymentCheckbox && (
                    <Form.Group className="mb-3" controlId="online">
                      <Form.Label>Online Wallet Remarks</Form.Label>
                      <Form.Control
                        type="text"
                        className="p-2"
                        disabled={isInputDisabled}
                        value={onlineWalletRemarks}
                        placeholder="Description"
                        onChange={(e) => setOnlineWalletRemarks(e.target.value)}
                      />
                    </Form.Group>
                  )} */}

                  <Form.Group className="mb-3" controlId="date">
                    <Form.Label>Issued Date (Maturity Date)</Form.Label>
                    <CustomDatePicker
                      label={"Issued Date"}
                      selected={date ? new Date(date) : ""}
                      handleDateChange={(date) => {
                        if (!date) {
                          setDate("");
                          return;
                        }
                        const toDateOnly = (d) => {
                          const r = new Date(d);
                          r.setHours(0, 0, 0, 0);
                          return r;
                        };
                        if (payDate && toDateOnly(date) < toDateOnly(payDate)) {
                          swal({
                            icon: "warning",
                            title: "Invalid Maturity Date",
                            text: "Maturity Date cannot be earlier than the Process Date.",
                            buttons: false,
                            timer: 2500,
                          });
                          return;
                        }
                        setDate(date);
                        setIsAmountDisabled(false);
                        // Replaced by checkCutoffDate (utils/cutoffDateValidation)
                        // dateValidation(date);
                        // postedCutoffValidation(date, setDate, "Issued Date");
                        warnCutoffDate(date, setDate, "Issued Date");
                      }}
                      setter={setDate}
                      CustomInput={CustomInput}
                      isRequired={true}
                      validated={validated}
                      // "Today" button
                      dateValidation={(today) =>
                        warnCutoffDate(today, setDate, "Issued Date")
                      }
                      setIsAmountDisabled={setIsAmountDisabled}
                      disabled={isInputDisabled}
                      minDate={
                        payDate
                          ? new Date(new Date(payDate).setHours(0, 0, 0, 0))
                          : undefined
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="amount">
                    <Form.Label>Amount</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>{currencyName}</InputGroup.Text>
                      {/* <Form.Control
                        type="text"
                        className="p-2"
                        required
                        placeholder="0.00"
                        disabled={isAmountDisabled}
                        value={amountInputted}
                        onInput={onInputFloat}
                        onChange={(e) => handleAmountValue(e.target.value)}
                      /> */}
                      <NumberInDecimals
                        className="form-control p-2"
                        required
                        placeholder="0.00"
                        value={amountInputted}
                        decimals={2}
                        onChange={handleAmountValue}
                        disabled={isAmountDisabled}
                      />
                    </InputGroup>
                    {accessType === "Management" && accountName && (
                      <span>
                        Account Balance:{" "}
                        <strong>{formatToTwoDecimal(bankAmount)}</strong>
                      </span>
                    )}
                  </Form.Group>

                  <Button
                    type="submit"
                    variant="primary"
                    disabled={isInputDisabled}
                    className="w-100 p-2"
                  >
                    Add Payment
                  </Button>
                </Form>
              </div>
            </Col>

            <Col xs={12} md={8} className="p-2 d-flex flex-column">
              <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav variant="tabs">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="paymentList"
                      className="text-dark custom-nav-link"
                    >
                      Payment List
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                      <Nav.Link
                        eventKey="AddExpenses"
                        className="text-dark custom-nav-link"
                      >
                        Add Expenses
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="DeductionExpenses"
                        className="text-dark custom-nav-link"
                      >
                        Deduction Expenses
                      </Nav.Link>
                    </Nav.Item> */}
                </Nav>

                <Tab.Content className="mt-3">
                  <Tab.Pane eventKey="paymentList">
                    <div className="border p-3 rounded">
                      <h5>Payment List</h5>
                      <Table bordered responsive>
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Transaction Number</th>
                            <th>Account Name</th>
                            <th>Amount</th>
                            <th>Check Number</th>
                            <th>Maturity Date</th>
                            {/* <th>Online Wallet</th>
                                <th>Online Reference No.</th> */}
                            {isEditing && <th>Action</th>}
                          </tr>
                        </thead>
                        {payments.some(
                          (data) =>
                            data.payment_status !== "Rejected" &&
                            data.isDeleted !== true,
                        ) || floatPayment.length > 0 ? (
                          <tbody>
                            {payments.map(
                              (data, i) =>
                                data.payment_status !== "Rejected" &&
                                data.isDeleted !== true && (
                                  <tr>
                                    <td>{data.payment_type}</td>
                                    <td>{data.transaction_number}</td>
                                    <td>
                                      {data.account_list_sub3.account_name ===
                                      ""
                                        ? "--"
                                        : data.account_list_sub3.account_name}
                                    </td>
                                    <td>{formatToTwoDecimal(data.amount)}</td>
                                    <td>
                                      {data.check_number === ""
                                        ? "--"
                                        : data.check_number}
                                    </td>
                                    <td>
                                      {format(data.date_issued, "MMM/dd/yyyy")}
                                    </td>
                                    {/* <td>
                                    {data.online_name === ""
                                      ? "--"
                                      : data.online_name}
                                  </td>
                                  <td>
                                    {data.online_ref_number === ""
                                      ? "--"
                                      : data.online_ref_number}
                                  </td> */}
                                    {isEditing && (
                                      <td>
                                        <button
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() =>
                                            deletePayment("payments", data, i)
                                          }
                                        >
                                          <i className="fa-solid fa-trash-can"></i>
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ),
                            )}

                            {floatPayment.map(
                              (data, i) =>
                                data.status !== "Rejected" &&
                                data.isDeleted !== true && (
                                  <tr>
                                    <td>{data.paymentMethod}</td>
                                    <td>
                                      {data.transaction_number
                                        ? data.transaction_number
                                        : "--"}
                                    </td>
                                    <td>
                                      {data.accountName === ""
                                        ? "--"
                                        : data.accountName}
                                    </td>
                                    <td>
                                      {formatToTwoDecimal(data.amountInputted)}
                                    </td>
                                    <td>
                                      {data.checkNumber === ""
                                        ? "--"
                                        : data.checkNumber}
                                    </td>
                                    <td>
                                      {format(data.issuedDate, "MMM/dd/yyyy")}
                                    </td>
                                    {/* <td>
                                          {data.remarks === ""
                                            ? "--"
                                            : data.remarks}
                                        </td>
                                        <td>
                                          {data.refNumber === ""
                                            ? "--"
                                            : data.refNumber}
                                        </td> */}
                                    {/* <td className="text-primary">Edit</td> */}
                                    {isEditing && (
                                      <td>
                                        <Button
                                          size="sm"
                                          variant="outline-danger"
                                          onClick={() =>
                                            deletePayment(
                                              "floatPayment",
                                              data,
                                              i,
                                            )
                                          }
                                        >
                                          <i className="fa-solid fa-trash-can"></i>
                                        </Button>
                                      </td>
                                    )}
                                  </tr>
                                ),
                            )}
                          </tbody>
                        ) : (
                          <caption className="text-center mt-3">
                            There are no records to display
                          </caption>
                        )}
                      </Table>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="AddExpenses">
                    <div className="border p-3 rounded">
                      <h5>Additional Expenses</h5>
                      <Table bordered hover responsive>
                        <thead>
                          <tr>
                            <th>Subject1</th>
                            <th>Subject2</th>
                            <th>Subject3</th>
                            <th>Remarks</th>
                            <th>Amount</th>
                            {selected_currency_id ===
                            "11111111-1111-1111-1111-111111111111" ? null : (
                              <>
                                <th>Rate</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {addDeducts
                            .filter((ad) => ad.type_expenses === "additional")
                            .map((ad, i) => (
                              <tr key={i}>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={
                                      ad.loan_id
                                        ? "Loan"
                                        : ad.account_list_sub3
                                            .account_list_base_sub.module_type
                                    }
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={
                                      ad.loan_id
                                        ? "Loan"
                                        : ad.account_list_sub3
                                            .account_list_base_sub.subject_name
                                    }
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={
                                      ad.loan_id
                                        ? ad.loan_mother.loan_name
                                        : ad.account_list_sub3.account_name
                                    }
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={ad.description}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={ad?.amount?.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                    readOnly
                                  />
                                </td>
                                {selected_currency_id ===
                                "11111111-1111-1111-1111-111111111111" ? null : (
                                  <>
                                    <td>
                                      <Form.Control
                                        type="text"
                                        value={ad.rate}
                                        readOnly
                                      />
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                        </tbody>

                        {renderExpenseTable("additional")}
                      </Table>

                      <br />
                      {isEditing && (
                        <Button
                          onClick={() => handleAdditionalExpenses("additional")}
                        >
                          Add New List
                        </Button>
                      )}
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="DeductionExpenses">
                    <div className="border p-3 rounded">
                      <h5>Deduction Expenses</h5>
                      <Table bordered hover responsive>
                        <thead>
                          <tr>
                            <th>Subject1</th>
                            <th>Subject2</th>
                            <th>Subject3</th>
                            <th>Remarks</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {addDeducts
                            .filter((ad) => ad.type_expenses === "deduction")
                            .map((ad, i) => (
                              <tr key={i}>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={
                                      ad.account_list_sub3.account_list_base_sub
                                        .module_type
                                    }
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={
                                      ad.account_list_sub3.account_list_base_sub
                                        .subject_name
                                    }
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={ad.account_list_sub3.account_name}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={ad.description}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    value={ad.amount}
                                    readOnly
                                  />
                                </td>
                                {selected_currency_id ===
                                "11111111-1111-1111-1111-111111111111" ? null : (
                                  <>
                                    <td>
                                      <Form.Control
                                        type="text"
                                        value={ad.rate}
                                        readOnly
                                      />
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                        </tbody>
                        {renderExpenseTable("deduction")}
                      </Table>
                      <br />
                      {isEditing && (
                        <Button
                          onClick={() => handleAdditionalExpenses("deduction")}
                        >
                          Add New List
                        </Button>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
              <Row className="mt-5">
                <Col sm>
                  <div className="d-flex justify-content-between">
                    <span>Expenses</span>
                    <span className="text-secondary">
                      {formatCurrency(expensesTotalAmount, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Overall Discount</span>
                    <span
                      className={`${
                        overallDiscount > 0
                          ? "text-danger"
                          : overallDiscount < 0
                            ? "text-success"
                            : "text-secondary"
                      }`}
                    >
                      {formatCurrency(overallDiscount, currencyName)}
                    </span>
                  </div>

                  {/* <div className="d-flex justify-content-between">
                    <span>Additional Expenses</span>
                    <span className="text-secondary">
                      {formatToTwoDecimal(totalAdditionalExpenses)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Deduction Expenses</span>
                    <span className="text-secondary">
                      {formatToTwoDecimal(totalDeductionExpenses)}
                    </span>
                  </div> */}
                  <div className="d-flex justify-content-between">
                    <span>Payments</span>
                    <span className="text-secondary">
                      {formatCurrency(totalPayment, currencyName)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded text-white">
                    <span>Payable Expenses</span>
                    <span>
                      {formatCurrency(
                        expensesTotalAmount +
                          totalAdditionalExpenses -
                          totalDeductionExpenses -
                          totalPayment -
                          overallDiscount,
                        currencyName,
                      )}
                    </span>
                  </div>
                </Col>
                <Col sm></Col>
                <Col sm>
                  <div className="d-flex justify-content-between">
                    <span>Cash</span>
                    <span className="text-secondary">
                      {formatCurrency(cashTotal, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Bank</span>
                    <span className="text-secondary">
                      {formatCurrency(bankTotal, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Check</span>
                    <span className="text-secondary">
                      {formatCurrency(checkTotal, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Online</span>
                    <span className="text-secondary">
                      {formatCurrency(onlineTotal, currencyName)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded text-white">
                    <span>Total Payment</span>
                    <span>{formatCurrency(totalPayment, currencyName)}</span>
                  </div>
                </Col>
              </Row>
              {bulkExpenses.status === "For-Approval" && (
                <Row className="mt-4">
                  <Col sm></Col>
                  <Col sm></Col>
                  <Col sm className="d-flex flex-row mb-2 w-100">
                    <div className="w-100 me-3">
                      {authrztn.includes(editPermission) && !isEditing && (
                        <Button
                          variant="outline-primary"
                          className="w-100 px-4"
                          type="button"
                          onClick={handleEditTransaction}
                        >
                          Edit
                        </Button>
                      )}
                    </div>
                    {authrztn.includes(approvePermission) && !isEditing ? (
                      <>
                        <Button
                          type="button"
                          className="w-100 me-3"
                          variant="outline-danger"
                          onClick={handleReject}
                          disabled={isCutoffPosted || !isCutoffExists}
                        >
                          Reject
                        </Button>
                        <Button
                          type="button"
                          className="w-100"
                          variant="outline-success"
                          onClick={handleApprove}
                          disabled={isCutoffPosted || !isCutoffExists}
                        >
                          Approve
                        </Button>
                      </>
                    ) : (
                      <>
                        {isEditing && (
                          <>
                            <Button
                              className="w-100 me-3"
                              variant="outline-danger"
                              type="button"
                              onClick={handleCancelEditTransaction}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="button"
                              variant="primary"
                              className="w-100"
                              onClick={handleUpdate}
                            >
                              Save
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </Col>

                  <div>
                    {(authrztn.includes("LocalExpenses-Edit") ||
                      authrztn.includes("LocalExpenses-Approve")) &&
                      isCutoffPosted && (
                        <div>
                          <p className="text-danger">
                            Action is prohibited as the Expenses date has
                            already been posted.
                          </p>
                        </div>
                      )}

                    {(authrztn.includes("LocalExpenses-Edit") ||
                      authrztn.includes("LocalExpenses-Approve")) &&
                      !isCutoffExists && (
                        <div>
                          <p className="text-danger">
                            Action is prohibited as the Expenses date has not
                            been created.
                          </p>
                        </div>
                      )}
                  </div>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default NewViewPayLocalExpenses;
